export default "__VITE_ASSET__830bd06a__"